<template>
  <div>
    <v-select :items="items" :value="value" @input="onChange">
      <template v-slot:selection="props">
        <ServeStatusIndicator
          v-if="props.item.value !== 'all'"
          :value="props.item.value"
          class="mr-2 pt-1"
        />
        {{ props.item.text }}
      </template>
      <template v-slot:item="props">
        <ServeStatusIndicator
          v-if="props.item.value !== 'all'"
          :value="props.item.value"
          class="mr-2 pt-1"
        />
        {{ props.item.text }}
      </template>
    </v-select>
  </div>
</template>

<script>
import { actions } from '@/vuex/modules/dashboard/constants'
import ServeStatusIndicator from './ServeStatusIndicator'

export default {
  name: 'ServeStatusFilter',
  components: { ServeStatusIndicator },
  props: { value: String },
  computed: {
    items() {
      return [
        { text: '配信期間中の全案件', value: 'all' },
        { text: '消化未達ペース', value: 'warning' },
        { text: '消化ペース注意', value: 'caution' },
        { text: '消化ペース順調', value: 'runRate' },
        { text: '前日未配信', value: 'notServe' },
      ]
    },
  },
  methods: {
    onChange(serveStatus) {
      console.log(serveStatus)
      this.$store.dispatch(actions.UPDATE_SERVE_STATUS_FILTER, serveStatus)
    },
  },
}
</script>
